import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import "../../css/feature.scss";

const more = (slug, firstname, content) => {
  const anon = "anonymous";

  let string;
  if (content === "graphics") {
    string = "View more"
    string += (slug === anon) ? ` ${anon}` : ` of ${firstname}'s`;
    string += " art";
  } else {
    string = "Read more";
    string += (slug === anon) ? ` ${anon}` : ` of ${firstname}'s`;
    string += " essays";
  }

  return string;
}

const Feature = ({ id, data, feature }) => (
  <div id={id} className="feature" style={{ color: data.textcolor }}>
    <div className="half-author">
      <p className="full-name">{data.name}</p>
      {(data.pronouns) && <p className="pronouns">({data.pronouns})</p>}
      <Link
        to={`/${data.slug}`}
        title={data.name}
        style={{ color: data.textcolor }}
        className="article"
      >
        {more(data.slug, data.firstname, data.content)}
      </Link>
    </div>
    <div className="half-excerpt">
      <a href={feature.link} target="_blank" rel="noreferrer" title={feature.link}
        style={{ color: data.textcolor }} className="quote">
        {(data.content === "graphics")
          ? <img className="graphics" src={feature.excerpt} alt={feature.alttext} />
          : <>&ldquo;{feature.excerpt}&rdquo; &#x2197;</>
        }
      </a>
    </div>
  </div>
);

Feature.propTypes = {
  data: PropTypes.shape({
    textcolor: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    pronouns: PropTypes.string.isRequired,
    firstname: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
  }),
  feature: PropTypes.shape({
    excerpt: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    alttext: PropTypes.string,
  }),
  id: PropTypes.string.isRequired,
}

Feature.defaultProps = {
  data: undefined,
  feature: undefined,
}

export default Feature;
